// =====================================
//
//   login Modal
//   Author: Gray
//   createtime: 2016 / 02 / 22
//   updatetime: 2016 / 02 / 22
//
// =====================================

window.InifECApp.directive('login', ['$rootScope', '$ngModal', '$timeout', '$state', '$localStorage', 'UserService', 'FacebookService', '$InifECGA', 'BusinessMemberService',
    function ($rootScope, $ngModal, $timeout, $state, $localStorage, UserService, FacebookService, $InifECGA, BusinessMemberService) {

        var _dir = {};

        var controller = ['$scope', '$element', function($scope, $element) {

            var loginWithEmail = function() {

                if($scope.isLoginWithEmail){
                    return;
                }

                resetLoginState();

                if(!$scope.form.email || !isEmail($scope.form.email)){
                    $scope.isEmailError = true;
                }

                if(!$scope.form.password){
                    $scope.isPasswordError = true;
                }

                if($scope.isEmailError || $scope.isPasswordError) {
                    return;
                }

                $scope.isLoginWithEmail = true;

                UserService.loginWithEmail($scope.form.email, $scope.form.password).then(function(result){
                    
                    closeModal();
                    $timeout(function(){
                        // 延遲一秒在結束比較不會造成視覺閃動
                        $scope.form.email = undefined;
                        $scope.form.password = undefined;
                        $scope.isLoginWithEmail = false;
                        $rootScope.$broadcast("LOGIN_SUCCESS");
                        $scope.callback && $scope.callback();

                        const mrscid = UserService.user.mrscid;
                        $InifECGA.eventTrack('member', 'login', mrscid);
                        $InifECGA.eventTrack('member', 'email_login', mrscid);
                    }, 1000);
                }, function(error){
                    $scope.isLoginWithEmail = false;

                    if(error && error.code === 'error.formValidator.passwordFailed'){
                        $scope.passwordFailed = true;
                    }else if(error && error.code === 'error.account.isFreeze'){
                        $scope.isMemberFreeze = true;
                    }else if(error && error.code === 'error.emailUnverified'){
                        $scope.emailUnverified = true;
                    }else if(error && error.code === 'error.account.accountNotExist'){
                        $scope.accountNotExist = true;
                    }else if(error && error.code === 'error.loginTypeError'){
                        $scope.loginTypeError = true;
                    }else{
                        $scope.isSystemError = true;
                    }
                });
            }

            var openFacebookForgotPasswordModal = function () {
                
                $rootScope.$broadcast("OPEN_FORGOT_PASSWORD_MODAL");

                closeModal();
            }

            var openFacebookDisableModal = function(){
                $rootScope.$broadcast("OPEN_CONFIRM_MODAL", {
                    confirmLabel:"設定您的密碼",
                    hideCancel: false,
                    title: "請使用您的Facebook的Email登入",
                    description: "<div style = 'text-align: left !important'>很抱歉，Facebook登入暫時有點問題<br>* 請點擊「確定」<br>* 輸入您Facebook帳號使用的Email系統將會寄送密碼重置信到您的信箱<br>非常抱歉造成您的不便敬請見諒<div>",
                    callback: function(result) {
                        if(result){
                            openFacebookForgotPasswordModal();
                        }
                    }
                });
            }

            var loginWithFacebook = function() {

                if($scope.isLoginWithFacebook){
                    return;
                }

                resetLoginState();
                
                $scope.isLoginWithFacebook = true;
                FacebookService.loginWithFacebook(true).then(function(result){
                    closeModal();
                    $scope.isLoginWithFacebook = false;
                   
                    $timeout(function(){
                        $rootScope.$broadcast("LOGIN_SUCCESS");
                        $scope.callback && $scope.callback();

                        const mrscid = UserService.user.mrscid;
                        $InifECGA.eventTrack('member', 'login', mrscid);
                        $InifECGA.eventTrack('member', 'fb_login', mrscid);
                    },1000);
                }, function(error) {
                    $scope.isLoginWithFacebook = false;
                    $scope.fbLoginErrorMsg = error.message;
                });
            }

            var openModal = function() {

                resetLoginState();
                $ngModal.openModal('login-modal');
                focusAccountInput(300);
            }

            var closeModal = function() {

                $ngModal.closeModal('login-modal');
            }

            var resetLoginState = function() {

                // 登入用的 whih email
                $scope.isLoginWithEmail = false;
                $scope.isEmailError = false;
                $scope.isPasswordError = false;
                $scope.passwordFailed = false;
                $scope.isSystemError = false;
                $scope.isMemberFreeze = false;
                $scope.emailUnverified = false;
                $scope.accountNotExist = false;
                $scope.loginTypeError = false;
                $scope.applicationReviewing = false;
                // 登入用的 whih facebook
                $scope.isLoginWithFacebook = false;
                $scope.facebookLoginError = false;
                $scope.isFbMemberFreeze = false;
                $scope.isConnectFacebookError = false;
                // 本服務正在測試階段，請先使用電子郵件申請成為會員
                $scope.isLoginSocailTest = false;
                // 企業用戶
                $scope.isLoginWithBusiness = false;
                $scope.isLoginkeyError = false;
            }

            var openForgotPasswordModal = function() {

                $rootScope.$broadcast("OPEN_FORGOT_PASSWORD_MODAL");

                closeModal();
            }

            var openResendInvitation = function(isBusinessMember) {

                var email = $scope.form.email;

                if($scope.loginType == 1) {

                    if(isEmail($scope.form.loginkey)) {
                        email = $scope.form.loginkey;
                    }
                }

                $rootScope.$broadcast("OPEN_RESEND_INVITATION_MODAL", {
                    email: email,
                    isBusinessMember: isBusinessMember,
                });

                closeModal();
            }

            var changeLoginType = function(loginType) {

                // 登入中就禁止切換狀態，避免出錯
                if($scope.isLoginWithEmail || $scope.isLoginWithFacebook || $scope.isLoginWithBusiness) {
                    return;
                }

                if(loginType == 0) {
                    $scope.form.email = $scope.form.loginkey;
                } else if(loginType == 1) {
                    $scope.form.loginkey = $scope.form.email;
                }

                resetLoginState();

                $scope.loginType = loginType;
                $localStorage.loginMeta.loginType = loginType;

                focusAccountInput();
            }

            var businessMemberLogin = function() {

                if($scope.isLoginWithBusiness){
                    return;
                }

                resetLoginState();

                if(!$scope.form.loginkey){
                    $scope.isLoginkeyError = true;
                }

                if(!$scope.form.password){
                    $scope.isPasswordError = true;
                }

                if($scope.isLoginkeyError || $scope.isPasswordError) {
                    return;
                }

                var loginMethod = undefined;

                if(isEmail($scope.form.loginkey)) {
                    loginMethod = BusinessMemberService.loginByEmail;
                } else {
                    loginMethod = BusinessMemberService.loginById;
                }

                $scope.isLoginWithBusiness = true;

                loginMethod($scope.form.loginkey, $scope.form.password).then(function(result){
                    
                    closeModal();
                    $timeout(function(){
                        // 延遲一秒在結束比較不會造成視覺閃動
                        $scope.form.loginkey = undefined;
                        $scope.form.password = undefined;
                        $scope.isLogin = false;
                        $rootScope.$broadcast("LOGIN_SUCCESS");
                        $scope.callback && $scope.callback();
                    }, 1000);
                }, function(error){
                    $scope.isLoginWithBusiness = false;

                    if(error && error.code === 'error.formValidator.passwordFailed'){
                        $scope.passwordFailed = true;
                    }else if(error && error.code === 'error.account.isFreeze'){
                        $scope.isMemberFreeze = true;
                    }else if(error && error.code === 'error.account.accountNotExist'){
                        $scope.accountNotExist = true;
                    }else if(error && error.code === 'error.apply.applicationReviewing'){
                        $scope.applicationReviewing = true;
                    }else if(error && error.code === 'error.emailUnverified'){
                        $scope.emailUnverified = true;
                    }else{
                        $scope.isSystemError = true;
                    }
                });
            }

            var openForgotBusinessPasswordModal = function() {

                $rootScope.$broadcast("OPEN_FORGOT_BUSINESS_PASSWORD_MODAL");

                closeModal();
            }

            var register = function() {

                $state.go(window.STATES.MEMBER_SIGNUP);

                closeModal();   
            }

            var registerBusimessMember = function() {

                $state.go(window.STATES.ENTERPRISE_SIGNUP, {
                    step: 'invitation',
                });

                closeModal();
            }

            var focusAccountInput = function(time) {

                if(!time) {
                    time = 10;
                }

                $timeout(function() {
                    $element.find('input[name="email"]').focus();
                }, time);
            }

            var init = function() {

                if(!$localStorage.loginMeta.loginType) {
                    $localStorage.loginMeta.loginType = 0;
                }

                if($localStorage.loginMeta.loginType != 0 && $localStorage.loginMeta.loginType != 1) {
                    $localStorage.loginMeta.loginType = 0;
                }

                $scope.loginType = 0; // $localStorage.loginMeta.loginType; // 0: 一般用戶, 1: 企業用戶
            }

            /*==========================
                Events
            ==========================*/

            $scope.$on("OPEN_LOGIN_MODAL", function(event, data) {

                $scope.callback = undefined;

                if(data && data.callback) {
                    $scope.callback = data.callback;
                }

                openModal();
            });

            /*==========================
                Members
            ==========================*/

            $scope.form = {
                loginkey: '',
                email: '',
                password: ''
            };
            
            // 登入用的 whih email
            $scope.isLoginWithEmail = false;
            $scope.isEmailError = false;
            $scope.isPasswordError = false;
            $scope.passwordFailed = false;
            $scope.isSystemError = false;
            $scope.isMemberFreeze = false;
            $scope.emailUnverified = false;
            $scope.accountNotExist = false;
            $scope.loginTypeError = false;
            $scope.applicationReviewing = false;
            // 登入用的 whih facebook
            $scope.isLoginWithFacebook = false;
            $scope.facebookLoginError = false;
            $scope.isFbMemberFreeze = false;
            $scope.isConnectFacebookError = false;
            // 本服務正在測試階段，請先使用電子郵件申請成為會員
            $scope.isLoginSocailTest = false;
            // 企業用戶
            $scope.isLoginWithBusiness = false;
            $scope.isLoginkeyError = false;

            $scope.loginType; // 0: 一般用戶, 1: 企業用戶

            $localStorage.$default({
                loginMeta: {},
            });

            /*==========================
                Methods
            ==========================*/

            $scope.loginWithEmail = loginWithEmail;
            $scope.loginWithFacebook = loginWithFacebook;
            $scope.openForgotPasswordModal = openForgotPasswordModal;
            $scope.openResendInvitation = openResendInvitation;
            $scope.changeLoginType = changeLoginType;
            $scope.businessMemberLogin = businessMemberLogin;
            $scope.openForgotBusinessPasswordModal = openForgotBusinessPasswordModal;
            $scope.register = register;
            $scope.registerBusimessMember = registerBusimessMember;
            $scope.callback;
            $scope.openFacebookDisableModal = openFacebookDisableModal;

            /*==========================
                init
            ==========================*/

            init();
        }]

        _dir.restrict = "E";
        _dir.scope = true;
        _dir.templateUrl = "partials/modal/login.html";
        _dir.controller = controller;

        return _dir;
    }]
);